export default __webpack_public_path__ + "static/media/113.5ab382a1.jpg";